import getModalContainer, { ModalContainer } from './Modal';
import Dialog from './Dialog';
import { type iOption } from './types';

export { Dialog };

class ModalHelper {
    private index: number = 1;
    private modalContainerInstance: any = null;
    private readonly getIndex = () => {
        this.index++;
        if (this.index >= 1000) {
            this.index = 1;
        }
        let nn = `${this.index}`;
        while (nn.length < 3) {
            nn = `0${nn}`;
        }
        return nn;
    };

    // 生产唯一模态框id
    uuid = () => `${~~(Date.now() / 1000)}${this.getIndex()}`;

    // Get or initialize the ModalContainer instance
    private async getModalContainerInstance() {
        if (!this.modalContainerInstance) {
            this.modalContainerInstance = await getModalContainer(ModalContainer);
        }
        return this.modalContainerInstance;
    }

    // Show modal asynchronously
    show = async (option: iOption) => {
        const uuid = this.uuid();
        const modalContainer = await this.getModalContainerInstance();
        modalContainer.showDialog({
            id: uuid,
            option,
        });
        return uuid;
    };

    // Close modal asynchronously
    close = async (id?: string) => {
        const modalContainer = await this.getModalContainerInstance();
        if (id) {
            modalContainer.removeDialog(id);
        } else {
            modalContainer.removeAll();
        }
    };
}

export default new ModalHelper();
